/**
 * Converts an object to a query string.
 * @param obj - The object to be converted.
 * @returns A query string representation of the object.
 */
export const stripBase64Images = (html: string): string =>
    html.replace(/src="data:[^"]*"/gi, 'src=""');

export const objectToQueryString = (obj: Record<string, any>): string => {
    const queryParams: string[] = [];

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            if (value !== undefined && value !== null) {
                queryParams.push(
                    `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
                );
            }
        }
    }

    return queryParams.join("&");
};